;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	
	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');
	
	Collection.Tipping =  Backbone.Collection.extend({
		url: function() {
			return this.methodUrl;
		},
		isNew: function(){
			return true;
		},
		show_my_list: function(id) {
			this.methodUrl = 'tip/show_my_list';
			return this;
		},
		autopick: function(data) {
			return this.setApiUrl('tip/autopick').save({data:data});
		},
		free_autopick: function(data) {
			return this.setApiUrl('tip/free_autopick').save({data:data});
		},
		get_gauntlet: function() {
			this.methodUrl = 'gauntlet/snapshot';
			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));